import Model from "../Model";

class VideowallCompany extends Model{

    buildUrl ({ param }) {
        return ['/videowallcompany', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new VideowallCompany;